import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OrgsComponent } from './orgs.component';
import {
  CanAuthenticationGuard,
  AuthGuard,
  AccessRightRespInfo,
  BlockPageAuthGuard,
} from '../../utils/authguard';
import { MaterialModule } from 'src/app/material/material.module';

const routes = [
  {
    path: 'orgs',
    component: OrgsComponent,
    canActivate: [
      CanAuthenticationGuard,
      AuthGuard,
      AccessRightRespInfo,
      BlockPageAuthGuard,
    ],
  },
];

@NgModule({
  declarations: [OrgsComponent],
  imports: [RouterModule.forChild(routes), TranslateModule, MaterialModule],
  exports: [OrgsComponent],
  providers: [CanAuthenticationGuard],
})
export class OrgsModule {}
